import { SnapActions } from 'src/app/model/map-actions/snap-actions';
import { SnapLayerAPIService } from './../../model/api-services/snap-layer-api.service';
import { SnapLayerSelectComponent } from './snap-layer-select/snap-layer-select.component';
import { MapDataAction } from './../../model/map-actions/map_data-action';
import {
  Component, Input, ViewChild, AfterContentInit,
  ElementRef, Output, EventEmitter, HostBinding,
  OnDestroy, ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';
import { AttributeInfo, AttributeRequirement, AnyHandler } from 'src/app/types/@types/sl-v-types';
import { SLLayer, LayerAccessLevel } from 'src/app/model/sl-layer';
import { ViewStackComponent } from '../view-stack/view-stack.component';
import { ViewStackViewComponent } from '../view-stack/view-stack-view/view-stack-view.component';
import { FeatureInfo } from '../results-view/results-view.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { FeatureService } from 'src/app/model/api-services/feature.service';
import { ModalMessagerService } from 'src/app/modal-messager/modal-messager.service';
import { Synchable, SynchEvent, SynchSelectionsEvent, ISelectionInfo } from 'src/app/model/synchronizer';
import { ResultsService, ResultMoment } from 'src/app/services/results.service';
import { StatefulCSS } from 'src/app/model/stateful_css';
import { LayerApiService } from 'src/app/model/api-services/layer-api.service';
import { IconButtonComponent } from '../icon-button/icon-button.component';
import { SLMap } from 'src/app/model/sl-map';
import { UUID } from 'angular2-uuid';
import { SynchButtonComponent } from '../synch-button/synch-button.component';
import { ModalResultStyleService } from '../dialogs/modal-result-style/modal-result-style.service';
import { MapService } from 'src/app/services/map.service';
import { CastingFormatType } from '../att-casting-view/formats/casting-formats-sel/casting-formats-sel.component';
import { Validator, ValidationResults, AvailabilityDict } from 'src/app/model/validator';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { AttStorageType, AttributesService } from 'src/app/model/api-services/attributes.service';
import { LayerSelectComponent } from '../layer-select/layer-select.component';
import { ActionGroupComponent } from '../action-group/action-group.component';
import { ActionGroupEvent } from 'src/app/types/actiongroupevent';
import { DigitizerComponent } from './digitizer/digitizer.component';
import { ISLMap } from 'src/app/types/@types/sl-map';
import { AttEditorComponent } from './att-editor/att-editor.component';
import { VertexToolsComponent } from './vertex-tools/vertex-tools.component';
import { EditorAction } from 'src/app/model/map-actions/editor-action';
import { NavigationAction } from 'src/app/model/map-actions/navigation-action';
import { InfoAction } from 'src/app/model/map-actions/info-action';
import { DrawPaneComponent } from '../draw-pane/draw-pane.component';
import { Dict } from 'src/app/types/decorable';
import { SelectionProxy } from 'src/app/model/selection-proxy';
import { SnapToolsComponent } from './snap-tools/snap-tools.component';
import { DistAngleToolsComponent } from './dist-angle-tools/dist-angle-tools.component';
import { SpreadToolsComponent } from './spread-tools/spread-tools.component';


@Component({
  selector: 'app-attribute-view',
  templateUrl: './attribute-view.component.html',
  styleUrls: ['./attribute-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AttributeViewComponent implements AfterContentInit, OnDestroy {

  public attributes: Array<AttributeInfo> = [];
  // public validator: Validator;
  public dataReady = false;
  public dataUpdated = true;
  private _displayMode: 'info' | 'editor' | '' = 'info';
  set displayMode(mode: 'info' | 'editor' | '') {
    this._displayMode = mode;
    const state = (mode === 'editor') ? 'editing' : mode;
    if (!!this.viewStates) {
      this.viewStates.SetState(state);
    }
    this.Refresh(true);
  }
  get displayMode(): 'info' | 'editor' | '' {
    if (!this.moment && (this._displayMode === 'info')) return '';
    return this._displayMode;
  }
  get rawDisplayMode(): 'info' | 'editor' | '' {
    return this._displayMode;
  }
  public geometries: Array<any> = [];
  public currentGeomI = -1;
  public editFeature: any = null;
  public get hasSnaps(): boolean {
    return !!this.drawPane && !!this.drawPane.GetSnaps();
    /*if (!this.drawPane) return false;
    return this.drawPane.GetSnaps()?.points?.points?.length > 0;
    */
  }

  private _distanceAngling: boolean = false;
  public set distanceAngling(isIt: boolean) {
    if (this._distanceAngling === isIt) return;
    this.HandleAdvUnset();
    this._distanceAngling = isIt;
    if (isIt) {
      this.views.SetView('dist-angle-tools')
      this.distAngleTools.Reset();
    }
    this.RefreshView();
  }
  public get distanceAngling(): boolean {
    return this._distanceAngling
  }

  private _vertexSpreading: boolean = false;
  public set vertexSpreading(isIt: boolean) {
    if (this._vertexSpreading === isIt) return;
    this.HandleAdvUnset();
    this._vertexSpreading = isIt;
    if (isIt) {
      this.SetView('spread-tools');
      this.spreadTools.Reset();
    }
    this.RefreshView();
  }
  public get vertexSpreading(): boolean {
    return this._vertexSpreading;
  }
  private _snapping: boolean = false;
  public set snapping(isIt: boolean) {
    if (this._snapping === isIt) return;
    this.HandleAdvUnset();
    this._snapping = isIt;
    if (isIt) {
      this.SetView('snap-tools');
      this.snapTools.Reset();
    }
    this.RefreshView();
  }
  public get snapping(): boolean {
    return this._snapping;
  }
  public name = 'Feature Viewer';
  public feature: any;
  public richText: SafeHtml = '';
  public currentNavView = 'feature';
  public currentView = 'info';
  public moment: ResultMoment = null;
  public channel = '-1';
  public viewList: Array<ViewStackViewComponent> = [];
  public visibleViewList: Array<ViewStackViewComponent> = [];
  public viewListReady = false;
  public count = 0;
  public offset = -1;
  public editLayer = '';
  public digitizing = false;
  @Output()
  public editLayerChange = new EventEmitter<string>();
  @Input()
  public layer: SLLayer;
  @Output()
  public layerChange = new EventEmitter<SLLayer>();




  private synchProxy: Synchable;
  private viewStates: StatefulCSS = new StatefulCSS();
  private selections: ISelectionInfo = null;
  public digitizerLayer: string = '';
  public digitizerLayerChange = new EventEmitter<string>();
  @HostBinding('class.attribute-view') attributeViewClass = true;
  @HostBinding('class.layer-edit') hasEditAccess = false;
  @HostBinding('class.layer-read') hasReadAccess = false;
  @HostBinding('class.layer-read-only') hasReadOnlyAccess = false;
  @HostBinding('class.full-height') isFullHeight = false;
  @HostBinding('class.is-expanded') isOpen = true;
  @ViewChild('snapTools', { static: true }) snapTools: SnapToolsComponent;
  @ViewChild('distAngleTools', { static: true }) distAngleTools: DistAngleToolsComponent;
  @ViewChild('spreadTools', { static: true }) spreadTools: SpreadToolsComponent;

  @ViewChild('vertexTools', { static: true }) vertexTools: VertexToolsComponent;
  @ViewChild('listSynchButton', { static: true }) listSynchButton: SynchButtonComponent;
  @ViewChild('pucSynchButton', { static: true }) infoSynchButton: SynchButtonComponent;
  @ViewChild('ddButton', { static: true }) ddButton: IconButtonComponent;
  @ViewChild('views', { static: true }) views: ViewStackComponent;
  @ViewChild('navViews', { static: true }) navViews: ViewStackComponent;
  @ViewChild('tabsElement', { static: true }) tabsElement: ElementRef;
  @ViewChild('attEditor', { static: true }) attEditor: AttEditorComponent;
  @ViewChild('snapLayerSel', { static: true }) snapLayerSel: SnapLayerSelectComponent
  @Input() mode = 'info';
  @Output() modeChange = new EventEmitter<string>();
  @Output() change = new EventEmitter<any>();

  public synchId = 'info';
  public layerResultI = 0;
  public layerResultCount = 0;
  public resultI = 0;
  public resultCount = 0;
  public results: any;
  public currentLayerName = '';
  public currentLayerI = 0;
  public currentLayer: any = null;
  public currentSLLayer: SLLayer;
  public currentFeature: any = null;
  public currentFeatureI = 0;
  public currentGids: Array<string> = [];
  public tooltip = '';
  private _map: SLMap;
  private validator = new Validator([]);
  @Input()
  public set slMap(map: SLMap) {
    this._map = map;
    if (!this.snapLayerSel) {
      window.requestAnimationFrame(() => {
        this.slMap = map;
      })
      return;
    }
    this.snapLayerSel.SetMap(this._map);
  }
  public get slMap(): SLMap {
    return this._map;
  }
  private _backless: string;
  @Input() set backless(isBackless: 'true' | 'false') {
    this._backless = isBackless;
  }
  get isBackless(): boolean {
    return this._backless === 'true';
  }
  public get refreshable(): boolean {
    if (!this.currentFeature) return;
    return !!this.currentFeature.gid;

  }
  public get hasGid(): boolean {
    if (this.digitizerLayer === '') return false;
    if (!this.digitizerLayer) return false;
    if (!this.attEditor.feature?.feature) return false;
    return (!!this.attEditor.feature.feature.gid)
  }
  public isSettingSelections = false;
  public listSyncing = false;
  public listSyncingChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  public pucSyncing = false;
  public pucSyncingChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  public isSynchingFeature = false;
  private subscriptions = new SubScriptionMgr();
  private subscriptionsSet = false;
  @Input() includeFeaturesButton: string;
  @HostBinding('class.result-popup') resultPopup = true;
  @ViewChild('resultArea', { static: true }) resultArea: ElementRef;

  @ViewChild('prevLayerButton', { static: true }) prevLayerButton: IconButtonComponent;
  @ViewChild('nextLayerButton', { static: true }) nextLayerButton: IconButtonComponent;
  @ViewChild('prevButton', { static: true }) prevButton: IconButtonComponent;
  @ViewChild('nextButton', { static: true }) nextButton: IconButtonComponent;
  @ViewChild('showInResultsButton', { static: true }) SIRButton: IconButtonComponent;

  @ViewChild('closeButton', { static: true }) closeButton: IconButtonComponent;
  @ViewChild('digitizer', { static: true }) digitizer: DigitizerComponent;

  @Output() actions: EventEmitter<any> = new EventEmitter(true);
  public layerService: LayerApiService;

  public get needDigitizerAdv(): boolean {
    if (!this.digitizer.HasDigitizerLayer()) return false;
    return this.displayMode !== 'info'
  }
  public get element(): HTMLElement {
    return this.domElement.nativeElement;
  }
  public get isFeatureView(): boolean {
    if (!this.viewStates) return false;
    return this.viewStates.GetCurrentState() === 'features';
  }
  public get isLayersView(): boolean {
    if (!this.viewStates) return false;
    return this.viewStates.GetCurrentState() === 'layers';
  }

  public hasResults = false;
  public hasResultsChange = new EventEmitter<boolean>();


  public currentSnapPt?: any;
  public currentSnapSeg?: any;

  private _drawPane: DrawPaneComponent;
  public drawPaneChanges?: SelectionProxy;
  public set drawPane(pane: DrawPaneComponent) {
    if (!!this._drawPane) return;
    this._drawPane = pane;
    this.drawPaneChanges = this._drawPane.selectionProxy;
    this.drawPaneChanges.RegisterListener('attribute-view', () => {
      this.HandleDrawPaneChange();
    })
    this.RefreshView();
    /*this.drawPane.selectionChange.subscribe((value: Dict) => {
      this.HandleDrawPaneChange();
    });
    */
    /*this.drawPane.GetSnaps().points.selectionChange.subscribe((value: Dict) => {
      this.currentSnapPt = value.source.GetSelectedInfo();
      this.HandleDrawPaneChange()
    })
    this.drawPane.GetSnaps().segments.selectionChange.subscribe((value: Dict) => {
      this.currentSnapSeg = value.source.GetSelectedInfo();
      this.HandleDrawPaneChange();
    })
    */

  }
  public get drawPane(): DrawPaneComponent {
    return this._drawPane;
  }

  private _ready = false;
  constructor(
    private domElement: ElementRef,
    private santizer: DomSanitizer,
    private featureSvc: FeatureService,
    private messager: ModalMessagerService,
    private resultsSvc: ResultsService,
    private stylesService: ModalResultStyleService,
    private mapSvc: MapService,
    private cdr: ChangeDetectorRef
  ) {
    const me = this;
    this.viewStates.SetPrefix('display');
    this.viewStates.AddState('features');
    this.viewStates.AddState('layers');
    this.viewStates.AddState('loading');
    this.viewStates.AddState('editing');
    this.viewStates.AddState('info');

    this.viewStates.SetMachine(this.domElement.nativeElement);
    this.viewStates.SetState('');
    this.synchProxy = {
      synchId: this.synchId,
      synchables: [],
      channel: 0,
      handler: (event: SynchEvent) => {
        me.HandleSynchEvent(event);
      }
    }
    this.resultsSvc.AddSynchable(this.synchProxy);

  }
  HandleExtras(params: any) {
    /*if (!!params.ppanelExpanded) {
      this.isOpen = params.ppanelOpened;
    }*/
    if (!!params.spanel) {
      if (typeof params.spanel === 'string') {
        params.spanel = params.spanel.split(',');
      }
      switch (params.spanel[0]) {
        case 'capture-attr':
          this.displayMode = 'editor';
          this.GoToAttributeEditor();
          break;
        case 'capture-geom':
          this.displayMode = 'editor';
          this.GoToGeomEditor();
          break;
      }
      if (params.hasOwnProperty('spanelExpanded')) {
        this.ToggleOpen(params.spanelExpanded);
      }
      if (params.def_cptr_lyr) {
        this.digitizerLayer = params.def_cptr_lyr;
        this.digitizerLayerChange.emit(this.digitizerLayer);
      }
      this.RefreshView();

    }

  }

  HandleSynchEvent(event: SynchEvent) {
    this.name = 'Feature Info';
    this.viewStates.SetState('features');
    const hasMoment = !!this.moment;
    const hasData = !!event.data;
    const hasDataMoment = (hasData) ? !!event.data.moment : false;
    if ((hasMoment && hasDataMoment) === true) {
      if ((event.source === 'history') /*&& (event.topic === 'moment-change')*/) {
        this.displayMode = 'info';
        // EditorAction.ShowEditor(this.slMap.component, {});
        switch (event.data.name) {
          case 'moment-pre-change':
            this.tooltip = 'Updating Feature ...';
            this.dataUpdated = false;
            this.RefreshView();
            return;
          case 'moment-change':
            const info: FeatureInfo = {
              feature: this.currentFeature,
              layer: this.currentSLLayer,
              index: this.currentFeatureI,
              count: this.currentLayer.features.length
            }
            this.ShowFeature(info, this.currentView);
            this.RefreshDataUpdated();
            InfoAction.OpenAttributePanel(this.currentSLLayer.SLMap.component, {});
            return;


        }
      }
    }

    let handlerName = 'Handle';
    const parts = event.topic.split('-');
    for (const part of parts) {
      handlerName += part[0].toUpperCase();
      handlerName += part.substr(1);
    }

    if (typeof this[handlerName] === 'function') {
      this[handlerName](event);
    }
    this.RefreshView();
  }
  HandleSetResults(event: SynchEvent) {
    switch (event.source) {
      case 'query-by-feature':
      case 'query':
      case 'roi-query':
        if (this.slMap.src.queryToInfo) {
          this.displayMode = 'info';
          this.RefreshView();
          event.data.moment =  this.slMap.resultsService.history.GetMoment(event.data.id);
          event.synchTo = this.synchId;
          this.HandleSynchSet(event);
          this.SelectLayer(0);
        }
    }
  }
  HandleRequestSynch(event: SynchEvent) {
    if (event.synchFrom === this.synchId) {
      switch (event.synchFrom) {
        case 'popup-control':
          this.pucSyncing = true;
          this.pucSyncingChange.emit(this.pucSyncing);
          break;
        case 'results-list':
          this.listSyncing = true;
          this.listSyncingChange.emit(this.listSyncing);
          break;
      }
    }
    if ((event.synchFrom !== this.synchId)) {
      return;
    }
    if (!this.moment) {
      return;
    }
    const synchDataevent: SynchSelectionsEvent = {
      channel: this.moment.id,
      data: { moment: this.moment, selections: this.selections },
      source: this.synchId,
      topic: 'synch-data',
      synchFrom: this.synchId,
      synchTo: event.synchTo
    }
    this.resultsSvc.Synch(synchDataevent);
  }
  HandleSelectionChange(event: SynchSelectionsEvent) {
    if (event.source === this.synchProxy.synchId) {
      return;
    }
    switch (event.source) {
      case 'results-list':
        if (!this.listSyncing) {
          return;
        }
        break;
      case 'result-popup':
      case 'popup-control':
        if (!this.pucSyncing) {
          return;
        }
        break;

    }
    this.isSynchingFeature = true;
    this.HandleSynchData(event);
    this.isSynchingFeature = false;
    this.RefreshView();


  }
  HandleSynchStateChange(event: SynchEvent) {
    switch (event.source) {
      case 'popup-control':
      case 'result-popup':
        this.pucSyncing = event.data.state;
        this.pucSyncingChange.emit(this.pucSyncing);
        this.isSynchingFeature = false;
        break;
      case 'results-list':
        this.listSyncing = event.data.state;
        this.listSyncingChange.emit(this.listSyncing);
        break;
    }
    this.RefreshView();
  }
  ngAfterContentInit() {
    this._ready = true;
  }
  HandleSynchSet(event: SynchSelectionsEvent) {
    if (event.synchTo !== this.synchId) {
      return;
    }
    this.moment = event.data.moment;
    this.results = this.moment.resultSet.results;
    this.channel = this.moment.id;
    this.synchProxy.channel = this.channel;
    this.resultsSvc.history.RegisterSynch(this.synchProxy.synchId, this.moment.id);
    /* this.resultsSvc.Synch({
      channel: this.synchProxy.channel,
      data: {},
      source: this.synchId,
      topic: 'request_synch',
      synchFrom: event.source,
      synchTo: this.synchId

    })*/
    this.RefreshView();
  }

  HandleSynchData(event: SynchSelectionsEvent) {
    if (!this.slMap) {
      this.slMap = this.mapSvc.GetMap();

    }
    if (event.synchTo !== this.synchProxy.synchId) {
      return;
    }
    this.hasResults = true;
    this.hasResultsChange.emit(true);
    this.displayMode = 'info';
    this.SetCurrentView();
    this.isSynchingFeature = true;
    this.HandleSynchSet(event);
    if (!this.selections) {
      if (!!event.data.selections) {
        this.slMap = (event.data.selections.layer as SLLayer).map as SLMap;
        this.selections = event.data.selections;
        this.resultsSvc.history.RegisterSelection(this.synchProxy.synchId, this.selections?.id);
        this.SelectionsChanged();
      } else {
        this.isSynchingFeature = false;
        this.SelectLayer(0, 0);
      }
      this.slMap.ShowInfo();
      this.isSynchingFeature = false;

      return;
    }
    if (!event.data!.selections) {
      const layer = this.moment?.resultSet.results[0].layer;
      this.SelectLayer(0, 0);
    }

    if (!!this.selections?.id) {
      this.selections = event.data.selections;
      this.resultsSvc.history.RegisterSelection(this.synchProxy.synchId, this.selections?.id);
      this.SelectionsChanged();
      this.slMap.ShowInfo();
      this.isSynchingFeature = false;
    }
    this.slMap.ShowInfo();

    this.RefreshView();
    this.HandleRenderRequest();
  }
  HandleRenderRequest(event?: SynchEvent) {
    if (!!event && event.synchFrom !== this.synchProxy.synchId) {
      return;
    }
    if (!!this.layer && !this.selections) {
      this.SelectLayer(0, 0);
    }

    if (!this.selections) return;
    this.resultsSvc.Synch(
      {
        channel: 'renderer',
        data: { moment: this.moment, selections: this.selections },
        source: this.synchProxy.synchId,
        topic: 'render',
        synchFrom: this.synchProxy.synchId,
        synchTo: 'renderer'
      }
    );
  }

  SelectionsChanged() {
    if (!this.selections) return;
    if (this.selections.features?.length > 0) {
      this.currentFeature = this.selections?.features[0];
    }
    this.currentSLLayer = this.selections?.layer;

    this.UpdateLayerI();
    this.UpdateFeatureI();
    this.SelectLayer(this.currentLayerI, this.currentFeatureI - 1);
    this.RefreshView();

  }
  UpdateLayerI() {
    let i = -1;
    for (const result of this.moment?.resultSet?.results) {
      i++;
      if (result.plid === this.currentSLLayer?.identifier) {
        this.currentLayerI = i;
        return i;
      }
    }
    this.RefreshView();
  }
  UpdateFeatureI() {
    let i = -1;
    // tslint:disable-next-line: no-shadowed-variable
    for (const feature of this.moment?.resultSet?.results[this.currentLayerI].features) {
      i++;
      if (feature.gid === this.currentFeature) {
        this.currentFeatureI = i + 1;
        return i;
      }
    }
    this.RefreshView();
  }

  ViewsReady() {
    this.viewListReady = false;
    this.viewList = [];
    this.visibleViewList = [];
    if (!!this.views) {
      for (let viewName in this.views.children) {
        if (!this.views.children.hasOwnProperty(viewName)) continue;
        const item = this.views.children[viewName];
        this.viewList.unshift(item);
        if (item.showInNav === true) {
          this.visibleViewList.unshift(item);
        }
      };
      setTimeout(() => {
        this.viewListReady = true;
      }, 50);
      this.SetView(this.mode);
      this.RefreshView();
    }
  }
  ShowFeature(featureInfo: FeatureInfo, initView = null, displayMode: 'info' | 'editor' = 'info'): void {
    const startMode = this.mode;
    this.dataReady = false;
    this.RefreshView();
    this.displayMode = displayMode;

    if (this.displayMode === 'info') {
      this.name = 'Feature Info';
      this.viewStates.SetState('features');
      if (!this.validator) {
        this.validator = new Validator(this.layer.layerAttributes);
        /*this.subscriptions.Subscribe(
          this.validator.validityChange, (changes: ValidationResults) => {
            if (changes.isValid === true) {
              this.currentFeature = this.validator.GetData();
              this.SaveChanges();
            }
          });
        */
        this.subscriptions.Subscribe(
          this.validator.availMapChange, (changes: AvailabilityDict) => {
            changes = null;
            // ToDO: Handle availMapChange(changes)
          });
        this.viewStates.SetState('features');
      }

      this.feature = (!!featureInfo.feature) ? featureInfo.feature : featureInfo;
      if (!!featureInfo.layer) {
        if (this.digitizer?.layer?.id !== featureInfo.layer.id) {
          this.digitizer.layerSel.SetLayer(featureInfo.layer);
        }
        this.layer = featureInfo.layer;
      } else {
        this.layer = this.currentLayer;
      }
      this.RefreshView(true);
      this.validator.SetAttributes(this.layer.layerAttributes);
      this.validator.SetData(this.feature);
      this.attributes = this.validator.attributes;
      this.dataReady = true;
      this.RefreshView();


    } else {
      this.name = 'Feature Editor';
      this.viewStates.SetState('digitizer');
      if (!!featureInfo.layer) {
        if (this.digitizerLayer !== featureInfo.layer.id) {
          this.digitizer.layerSel.SetLayer(featureInfo.layer);
        }
      } else {
        this.layer = this.currentLayer;
      }
    }
    this.attEditor.ShowFeature(featureInfo);


    this.layerChange.emit(this.layer);
    this.RefreshView();
    const unfeatures = this.currentGids.slice(0);
    // this.attributes = this.validator.attributes;
    if (this.displayMode === 'info') {
      if (this.currentFeature.hasOwnProperty('gid')) {
        unfeatures.splice(unfeatures.indexOf(this.currentFeature.gid), 1);
      }
    }
    this.RefreshView();
    if (!!this.currentLayer) {
      const synchTo: Array<string> = [];
      if (this.listSyncing === true) {
        synchTo.push('results-list');
      }
      if (this.pucSyncing === true) {
        synchTo.push('popup-control');
      }
      if ((!this.isSynchingFeature) && (this.displayMode === 'info')) {
        this.selections = {
          id: UUID.UUID(),
          layer: this.currentSLLayer,
          layerId: this.currentSLLayer.identifier,
          selectionMode: 'single',
          features: [this.currentFeature.gid],
          unfeatures: (unfeatures)
        }
        const selectionsEvent: SynchSelectionsEvent = {
          channel: this.moment.id,
          data: { moment: this.moment, selections: this.selections },
          source: this.synchId,
          topic: 'selection-change',
          synchTo: (synchTo.join(',')),
          synchFrom: this.synchProxy.synchId
        }
        const renderEvent: SynchSelectionsEvent = {
          channel: 'renderer',
          data: { moment: this.moment, selections: this.selections },
          source: this.synchId,
          topic: 'render'
        }
        if (synchTo.length > 0) {
          this.resultsSvc.Synch(selectionsEvent);
        }
        this.resultsSvc.history.RegisterSelection(this.synchId, this.selections?.id);
        this.resultsSvc.Synch(renderEvent);

      }

      if (this.displayMode === 'info') {
        this.richText = this.santizer.bypassSecurityTrustHtml(this.currentSLLayer.GetTooltipText(this.currentFeature, true));
      }
      const layer = this.displayMode === 'info' ? this.currentSLLayer : this.layer;
      if (Number(layer.access) === 1) {
        this.hasReadOnlyAccess = true;
        this.hasReadAccess = true;
      }
      if (Number(layer.access) > 1) {
        this.hasReadOnlyAccess = false;
        this.hasReadAccess = true;

      }
      this.hasEditAccess = Number(layer.access) >= 3;

      this.RefreshView();
    }

    this.isOpen = false;
    this.dataReady = false;
    this.RefreshView();
    if (initView !== null) {
      this.currentView = initView;
    }
    this.SetCurrentView();
    this.RefreshView();
    this.navViews.SetView('feature');
    this.RefreshView();
    this.isOpen = true;
    this.dataReady = true;
    this.RefreshView();
    if (this.currentSLLayer && this.displayMode === 'info') {
      InfoAction.OpenAttributePanel(this.currentSLLayer.SLMap.component, {});

    }
    this.mode = startMode;
    this.RefreshView(true);
  }
  NewFeature() {
    this.attEditor.Clear();
    this.GoToGeomEditor();
    this.digitizer.TurnOn();

  }


  Reset() {
    this.moment = undefined;

    this.vertexTools.Reset();
    this.attEditor.Reset();


  }
  SubmitForm(event?: any): boolean {
    //this.RefreshView();
    //this.validator.Validate()
    return this.attEditor.SubmitForm(event, (result) => {
      this.vertexTools.Reset();
      for (const layer of this.slMap.layers) {
        if (layer.id === 'selected') layer
      }
      InfoAction.FeatureEdit(this.slMap.component, result);

    });
    //event.target.checkValidity();

  }
  SetView(viewName: string) {
    this.mode = viewName;
    this.modeChange.emit(viewName);

    this.currentView = viewName;
    this.views.SetView(this.currentView);
    this.dataUpdated = false;
    this.RefreshView();
    this.RefreshDataUpdated();
  }
  ResetTools() {
    this.HandleAdvUnset();
  }
  HandleViewChange() {
    const view = this.views.currentView.viewName;
    if (view !== 'snap-tools') this.snapTools.Reset();
    if (view !== 'dist-angle-tools') this.distAngleTools.Reset();
    if (view !== 'spread-tools') this.spreadTools.Reset();
  }
  GetValue(attributeName: string) {
    return this.currentFeature[attributeName];
  }
  SetValue(attributeName: string, attributeValue: any) {
    this.currentFeature[attributeName] = attributeValue;
    this.RefreshView();
  }
  IsNumeric(attribute: AttributeInfo): boolean {
    return ['int', 'float'].indexOf(attribute.requires) > -1;
  }
  GetViewValue(attribute: AttributeInfo): any {
    const val = this.currentFeature[attribute.name];
    const rawValue = AttributesService.GetValue(attribute, val);
    const displayValue = AttributesService.GetDisplayValue(attribute, rawValue);
    return this.santizer.bypassSecurityTrustHtml(displayValue);
  }

  BoolVal(attributeName: string): any {
    if (!this.HasValue(attributeName)) {
      return false;
    }
    return (this.currentFeature[attributeName] === 't') ? true : false;
  }
  SetBoolValue(attributeName: any, value: string) {
    this.currentFeature[attributeName] = (value === 'true') ? 't' : 'f';
  }
  HasValue(attributeName: string) {
    if (this.displayMode === 'info') {
      if (!this.currentFeature) return false;
      return ([null, ''].indexOf(this.currentFeature[attributeName]) === -1);
    } else {
      if (!this.feature) return false;
      return ([null, ''].indexOf(this.feature[attributeName]) === -1);
    }
  }
  UpdateHeight(height: number, panelMax: number = null) {
    panelMax = panelMax;
    this.domElement.nativeElement.style.clientHeight = (height === 0) ? '2.5em' : height + 'px';
    // this.views.element.nativeElement.style.height = height + 'px';
  }
  Back() {
    this.resultsSvc.history.synchSet['info'] = null;
    this.moment = null;

    this.digitizer.TurnOff();
    this.change.emit({ target: this, action: 'back', displayMode: this.displayMode });
    MapDataAction.Exec('legend-toggle', this.slMap.component, { selected: true });
    /*if (this.displayMode === 'editor') {
      EditorAction.CloseEditor(this.slMap.component, {});
    } else {
      EditorAction.CloseInfo(this.slMap.component,{});
    }*/
  }
  ToggleOpen(isOn?: boolean) {
    if (this.isOpen === isOn) {
      this.isFullHeight = !this.isOpen;

      this.change.emit({ target: this, action: 'open_close' });
      this.Refresh();

      return;
    }
    if (isOn === true || isOn === false) {
      this.isOpen = isOn;
    } else {
      this.isOpen = !this.isOpen;
    }
    this.isFullHeight = !this.isOpen;
    (this.domElement.nativeElement as HTMLDivElement).parentElement.classList.toggle('is-collapsed', !this.isOpen);
    this.change.emit({ target: this, action: 'open_close' });
    this.Refresh(true);

  }
  UpdateData() {
    this.dataUpdated = false;
    setTimeout(() => {
      this.dataUpdated = true;
    }, 50);
  }
  SaveChanges() {
    if (this.displayMode === 'info') {
      if (!this.moment) return;
      this.resultsSvc.history.PreUpdateMoment(this.moment);
      // const savedFeature = this.currentFeature;

      this.messager.Progress('Saving feature', false, .5, 'Saving ...');
      this.featureSvc.UpdateFeature(this.layer, this.currentFeature.gid, this.attEditor.GetData()).then(
        (result: any) => {
          this.currentLayer.features[this.currentFeatureI - 1] = result.record;
          this.currentFeature = this.moment.resultSet.results[this.currentLayerI - 1].features[this.currentFeatureI - 1];
          this.messager.Progress('Feature saved, updating displays', true, .75, 'Saving ...');
          this.UpdateData();
          this.change.emit({
            action: 'change',
            target: this,
            layer: this.currentSLLayer,
            feature: this.currentFeature,
            featureId: this.currentFeature.gid
          });
          this.resultsSvc.history.UpdateMoment(this.moment, false);
          this.richText = this.currentSLLayer.GetTooltipText(this.currentFeature, true);
          this.messager.Progress('Feature saved', true, 1, 'Saving ...');
        }

      );
    } else {
      this.SubmitForm();
      return;
    }

  }
  get hasNext(): boolean {
    if (this.hasResults === false) {
      return false;
    }
    if (!(!!this.currentLayer)) {
      return false;
    }
    return this.currentLayer.features.length > this.currentFeatureI;
  }
  get hasPrev(): boolean {
    if (!(!!this.currentLayer)) {
      return false;
    }
    if (this.hasResults === false) {
      return false;
    }
    return (this.currentFeatureI > 1) && (this.currentLayer.features.length > 1);
  }
  get singleFeature(): boolean {
    return this.currentLayer?.features?.length <= 1;
  }

  get singleLayer(): boolean {
    return this.moment?.resultSet?.layerCount <= 1;
  }
  get hasNextLayer(): boolean {
    if (this.hasResults === false) {
      return false;
    }
    if (!this.viewStates) return false;
    if (this.viewStates.GetCurrentState() === 'layers') return false;

    if (!this.currentLayerI) {
      return false;
    }
    if (!this.layerResultCount) {
      return false;
    }
    return this.currentLayerI < this.layerResultCount;
  }
  get hasPrevLayer(): boolean {
    if (this.hasResults === false) {
      return false;
    }
    if (!this.viewStates) return false;
    if (this.viewStates.GetCurrentState() === 'layers') return false;
    /*if (this.views.currentView.viewName === 'layers') {
      return false;
    }*/
    if (!this.currentLayerI) {
      return false;
    }

    return this.currentLayerI > 1;
  }
  /*HasNextLayer(): boolean {
    if (!(!!this.views.currentView)) {
      return false;
    }
    if (this.views.currentView.viewName === 'layers') {
      return false;
    }
    if (!this.currentLayerI) {
      return false;
    }
    if (!this.layerResultCount) {
      return false;
    }
    return this.currentLayerI < this.layerResultCount;
  }
  HasPrevLayer(): boolean {
    if (!(!!this.views.currentView)) {
      return false;
    }
    if (this.views.currentView.viewName === 'layers') {
      return false;
    }
    if (!this.currentLayerI) {
      return false;
    }

    return this.currentLayerI > 1;
  }*/
  NextLayer(update: boolean = true) {
    update = update;
    if (!this.hasNextLayer) {
      this.currentLayerI = 0;
    }
    this.SelectLayer(this.currentLayerI);
  }
  PrevLayer(update: boolean = true) {
    if (!this.moment) return;
    update = update;
    if (!this.hasPrevLayer) {
      this.currentLayerI = this.moment.resultSet.layerCount + 1;

    }
    this.SelectLayer(this.currentLayerI - 2);
  }
  Next(update: boolean = true) {
    if (!this.moment) return;
    if (!this.hasNext) {
      this.currentFeatureI = 0;
    }
    this.currentFeatureI++;
    if (this.currentLayer.features.length <= this.currentFeatureI - 1) {
      this.currentFeature = null;
      return null;
    }
    this.currentFeature = this.currentLayer.features[this.currentFeatureI - 1];
    if (update === true) {
      this.SetStats();
      const info: FeatureInfo = {
        feature: this.currentFeature,
        layer: this.currentSLLayer,
        index: this.currentFeatureI,
        count: this.currentLayer.features.length
      }
      this.ShowFeature(info, this.currentView);
    }
    return this.currentFeature;
  }
  Prev() {
    if (!this.hasPrev) {
      this.currentFeatureI = this.currentLayer?.features?.length + 1;
    }
    this.currentFeatureI--;
    this.currentFeature = this.currentLayer.features[this.currentFeatureI - 1];
    this.SetStats();
    const info: FeatureInfo = {
      feature: this.currentFeature,
      layer: this.currentSLLayer,
      index: this.currentFeatureI,
      count: this.currentLayer.features.length
    }
    this.ShowFeature(info, this.currentView);
  }
  ShowLayers(which: 'layers' | 'features' | 'null') {
    if (!this.navViews || !this.navViews.currentView || !this.navViews.currentView.viewName) {
      return;
    }
    if ((this.navViews.currentView.viewName === 'layers') || which === 'features') {
      this.currentNavView = 'feature';
      this.navViews.SetView(this.currentNavView);
      this.viewStates.SetState('features');

    } else if ((this.navViews.currentView.viewName === 'layers') || which === 'layers') {
      this.navViews.SetView('layers');
      this.currentNavView = 'layers';
      this.viewStates.SetState('layers');

    }


  }
  SelectLayer(i: number, featureI = null) {
    this.currentLayerI = i + 1;
    this.currentLayer = this.results[this.currentLayerI - 1];
    if (!!this.currentLayer.plid) {
      this.layer = this.slMap.GetLayerById(this.currentLayer.plid, true);
    }
    this.currentGids = [];
    // tslint:disable-next-line: no-shadowed-variable
    for (const feature of this.currentLayer.features) {
      this.currentGids.push(feature.gid);
    }
    if (!!this.currentLayer.plid) {
      this.currentSLLayer = this.slMap.GetLayerById(this.currentLayer.plid, true);
    } else {
      this.currentSLLayer = this.slMap.GetLayerById(this.currentLayer.layer);
    }
    this.currentLayerName = this.currentSLLayer.name;
    if (this.currentLayer.features.length > 0) {
      if (featureI !== null) {
        this.currentFeature = this.currentLayer.features[featureI]
        this.currentFeatureI = featureI + 1;
      } else {
        if (!this.isSettingSelections) {
          this.currentFeature = this.currentLayer.features[0];
          this.currentFeatureI = 1;
        }
      }
    }
    this.SetStats();
    const info: FeatureInfo = {
      feature: this.currentFeature,
      layer: this.currentSLLayer,
      index: this.currentFeatureI,
      count: this.currentLayer.features.length
    }
    this.ShowFeature(info, this.currentView);

  }
  SetStats() {
    this.layerResultCount = this.results.length;
    this.layerResultI = this.currentLayerI;
    this.resultCount = this.currentLayer.features.length;
    this.resultI = this.currentFeatureI;
  }
  HandleListSynchChange(event: any) {
    event = null;
  }
  HandlePucSynchChange(event: any) {
    event = null;

  }
  ZoomToFeature() {
    this.slMap.component.HandleToolAction({
      action: 'info/zoom-to-features',
      layer: this.selections.layer.id,
      features: this.currentFeature.gid
    });
  }
  Config() {
    let type = 'selected';
    const isPLayer = !!this.currentLayer.plid;
    const layer: SLLayer = this.slMap.GetLayerById(isPLayer ? this.currentLayer.plid : this.currentLayer.lid, isPLayer);
    if (layer.type === 9002) {
      type = 'selected';
    }
    if (layer.type === 9003) {
      type = 'unselected';
    }
    this.stylesService.GetStyles(() => {
      layer.Touch();
      layer.Render();
      this.slMap.UpdateResults();
    }, this.slMap, type);
  }
  WhichInput(attribute: AttributeInfo): CastingFormatType | AttributeRequirement {

    if (!!attribute.casting) {
      if (!!attribute.casting.entry) {

        return attribute.casting.entry.type;
      }
    }
    switch (attribute.requires as AttStorageType) {
      case 'text':
      case 'string':
        if (['url', 'cg_url'].indexOf(attribute.requires) > -1) {
          return 'url';
        }
        return 'text';
      case 'boolean':
        return 'boolean';
      case 'date':
        return 'date';
      case 'time':
        return 'time';
      case 'float':
      case 'int':
        return 'number-general'
      case 'cg_url':
      case 'url':
        return 'link';
    }
  }
  IsInput(attribute: AttributeInfo, type: CastingFormatType | AttributeRequirement): boolean {
    if (!AttributesService.IsVisible(attribute)) {
      return false;
    }
    return this.WhichInput(attribute) === type;
  }
  RefreshDataUpdated() {
    window.requestAnimationFrame(() => {
      this.dataUpdated = true;
      this.RefreshView();
    });
  }
  EditFeature(featureInfo: any) {
    this.displayMode = 'editor';
    this.editFeature = featureInfo;
    this.RefreshView();
    this.GoToAttributeEditor();
    this.digitizer.TurnOn();
  }
  HasPrevGeom(): boolean {
    return (this.currentGeomI > 0);
  }
  HasNextGeom(): boolean {
    return (this.currentGeomI < this.geometries.length);

  }
  HasGeom(): boolean {
    return (this.geometries.length > 0);
  }
  ngOnDestroy(): void {
    this.subscriptions.CancelSubscriptions();
  }
  NextGeom() {

  }
  PrevGeom() {

  }

  SetEditFeature(map: SLMap, feature) {
    this.name = 'Feature Editor';
    this.viewStates.SetState('digitizer');
    this.slMap.component.drawPane.SetLayer(feature.layer);
    this.feature = undefined;
    this.digitizer.SetFeature(feature, map, false);
    this.SetFeatureWhenReady(feature);
    this.RefreshView();

  }
  private SetFeatureWhenReady(feature) {
    setTimeout(() => {
      if (this.attEditor.handlingLayer === true) {
        this.SetFeatureWhenReady(feature);
        return;
      }
      this.name = 'Feature Editor';
      this.viewStates.SetState('digitizer');
      this.displayMode = 'editor';
      this.drawPane.Clear();
      this.displayMode = 'editor';
      this.ShowFeature(feature, this.currentView, this.displayMode);
      this.GoToAttributeEditor();
      this.RefreshView();
      this.Refresh(false);

    }, 0);

  }
  LayerSelReady(_layerSel?: LayerSelectComponent) {
    /*this.subscriptions.Subscribe(_layerSel.layerChange, (layer: SLLayer) => {
      if (this.layer && (this.layer.id !== layer.id)) {
        this.layer = layer;
        this.RefreshView();
      }

    });*/
    // this.layerSel.SetMap(this.slMap);
  }
  HandleLayerChange(layer: SLLayer | '') {
    if (layer === null) layer = '';
    this.drawPane = this.slMap.component.drawPane;
    if (layer === '') {
      this.slMap.component.ToggleInteraction('digitizing', false);
      this.digitizerLayer = '';
      this.digitizerLayerChange.emit(this.digitizerLayer);
    } else {
      this.slMap.component.ToggleInteraction('digitizing', this._displayMode === 'editor');
    }
    if (this._displayMode === 'editor') {
      this.slMap.component.drawPane.SetLayer(layer);
      this.digitizerLayer = (layer === '') ? '' : ((layer !== null) ? layer.id : '');
      this.digitizerLayerChange.emit(this.digitizerLayer);

      this.snapping = false;
      this.distanceAngling = false;
      this.vertexSpreading = false;

      this.vertexTools.DigitizerUpdated();
      if (!layer) {
        this.views.SetView('need-layer');
      } else {
        this.views.SetView('edit');
        this.NewFeature();


      }
    }
    this.Refresh();
    this.RefreshView();
    return;
    /* if (this.displayMode === 'editor') {
      this.layer = layer;
      this.editFeature = this.layer.GetEmptyRecord();
      this.RefreshView();
      const featureInfo: FeatureInfo = {
        count: 1,
        feature: this.editFeature,
        index: 0,
        layer: (layer)
      }
      this.ShowFeature(featureInfo, this.views.currentView.viewName, this.displayMode);

    }
    */
    // do nothing
  }

  GoToAttributeEditor(): boolean {
    const wasEditorMode = this._displayMode === 'editor';
    const wasOpen = this.isOpen;
    this.ShowLayers('features');
    this.name = 'Feature Editor';
    this.digitizing = true;
    this.digitizer.TurnOn();
    this.views.SetView('edit');
    this.displayMode = 'editor';
    this.RefreshView();
    if (this.digitizer.HasDigitizerLayer() === false) {
      this.views.SetView('need-layer');
      this.navViews.SetView('feature');
      this.displayMode = 'editor';
    } else {
      this.views.SetView('feature');
      this.navViews.SetView('feature');
    }


    // this.dataReady = true;
    this.RefreshView();
    this.cdr.detectChanges();
    window.requestAnimationFrame(() => {

      if (wasEditorMode === false) {
        if (this.digitizer.HasDigitizerLayer() === true) {
          this.attEditor.NewFeature(this.digitizer.layer);
        }
        this.ToggleOpen(true);
        return;
      }
      this.Refresh(true);


    });
    return wasEditorMode;
  }
  GoToGeomEditor(): boolean {
    const wasEditorMode = this.displayMode === 'editor';
    const wasOpen = this.isOpen;
    this.ShowLayers('features');
    this.name = 'Feature Editor';
    this.digitizing = true;
    this.digitizer.TurnOn();
    this.views.SetView('geom-editor');
    this.displayMode = 'editor';
    this.RefreshView();
    this.Refresh(true);
    if (this.digitizer.HasDigitizerLayer() === false) {
      this.views.SetView('need-layer');
    } else {
      this.views.SetView('edit');
    }
    // this.dataReady = true;
    this.RefreshView();
    window.requestAnimationFrame(() => {

      if (wasEditorMode === false) {
        if (this.digitizer.HasDigitizerLayer() === true) {
          this.attEditor.NewFeature();
        }
        this.ToggleOpen(true);
        return;
      }
      this.Refresh(true);

    })
    return wasEditorMode;

  }
  SetCurrentView() {
    if (this._displayMode === 'info') {
      if (['info', 'read'].indexOf(this.currentView) === -1) {
        this.SetView('info');
        // this.SetView(this.currentView);

      } else {
        this.SetView(this.currentView);
      }
    } else {
      if (['info', 'read'].indexOf(this.currentView)) {
        this.SetView('editor');
      } else {
        this.SetView('info');
        //this.SetView(this.currentView);
      }

    }
    this.ToggleOpen(true);
  }
  LatLonFormatChanged() {
    this.attEditor.Redraw();
  }
  GetSubmitHandler(): AnyHandler {
    const me = this;
    return (feature: any) => {
      me.SubmitHandler(feature as FeatureInfo);
    }
  }
  GetDeleteHandler(): AnyHandler {
    const me = this;
    return () => {
      me.vertexTools.NewFeature(true);

    }
  }
  SubmitHandler(feature: FeatureInfo) {
    switch (this.displayMode) {
      case 'editor':
        if (feature && feature.layer) {
          //const emptyFeature = feature.layer.GetEmptyFeatureInfo();
          // this.digitizer.drawPane.Clear();//.NewFeature();
          this.SetEditFeature(this.slMap, feature);
          if (feature.layer) feature.layer.SLMap.RefreshResultsIfLayer(feature.layer);

        }
        return;
      case 'info':
        if (feature) {
          this.ShowFeature(feature);
        }
        return;
    }

  }
  SwitchViews() {
    if (this.isLayersView) {
      this.ShowLayers('features');
    } else {
      this.ShowLayers('layers');
    }
  }

  Refresh(cdrOnly: boolean = false) {
    if (this._displayMode === 'info') return;
    if (this._displayMode === '') return;
    if (!!this.attEditor?.feature?.feature?.gid) {
      if (this.digitizerLayer !== '') {
        if (!cdrOnly) {
          this.drawPane.ShowFeature({ layer: this.attEditor.layer, gid: this.attEditor.feature.feature.gid }, () => { });
        }
      }
    }
    this.attEditor.Refresh(cdrOnly);

  }
  RefreshView(force = false) {
    if (!!this._ready) {
      if (force) {
        this.cdr.markForCheck();
      }
      this.cdr.detectChanges();
    }
  }
  HandleAdvUnset() {
    this._vertexSpreading = false;
    this._distanceAngling = false;
    this._snapping = false;
    this.snapTools.Reset();
    this.distAngleTools.Reset();
    this.spreadTools.Reset();
    if (this._displayMode === 'editor') {
      this.views.SetView('edit');
    }
  }
  public snapLayer?: SLLayer;
  HandleSnapLayerSel(layer: SLLayer) {
    if (!layer) {
      this.snapLayer = undefined;
      return;
    }
    if (this.snapLayer?.identifier === layer.identifier) return;
    this.snapLayer = layer;
    // EditorAction.ToggleSnaps(layer.SLMap.component, { state: true });
    this.snapLayer.map.snapLayerService.SelectSnapLayer(layer);

  }
  IsVisible(attribute: AttributeInfo): boolean {
    return AttributesService.IsVisible(attribute);
  }
  public updated = false;

  public currentSegment?: any;

  public currentVertex?: any;
  HandleDrawPaneChange() {
    const info = this.drawPane.GetSelectedFeature().GetSelectedInfo();
    this.updated = !info;
    this.cdr.detectChanges();
    this.currentSegment = this.drawPaneChanges.GetProperty('segment');
    this.currentVertex = this.drawPaneChanges.GetProperty('vertex');
    this.currentSnapPt = this.drawPaneChanges.GetProperty('snapVertex');
    this.currentSnapSeg = this.drawPaneChanges.GetProperty('snapSegment');
    let hasTool = false;
    let req = this.snapTools.requiredDrawMode;
    if (req === '') {
      req = this.distAngleTools.requiredDrawMode;
    }
    if (req === 'snap') {
      this.drawPane.SnapOn(this.drawPane.snapGeomMode);

    } else {
      this.drawPane.SnapOff();
      this.drawPane.SetInteractionMode('feature');
    }
    if (this.snapTools.addingAt || this.snapTools.moving) {
      this.slMap.component.DisableNavigation();
    } else {
      this.slMap.component.EnableNavigation();
    }


    this.RefreshView();
  }
  HandleToolChange(_tool: string) {
    this.HandleDrawPaneChange();
  }
  PowerOff() {
    this.digitizerLayer = '';
    this.attEditor.layerSel.Reset();
    this.snapLayerSel.Reset();
    this.digitizer.TurnOff();
    this.drawPane.Clear().NewFeature();
    this.drawPane.SnapOff();
    this.drawPane.ClearSnaps();

    this.RefreshView();
  }
  RefreshSnaps() {
    MapService.Get().snapLayerService.RefreshSnaps();
  }
}
